import { EnumReadingDtoProps } from "./DTOs/EnumReadingDto"

export const formasCobroPagoAdapter = (
  item: EnumReadingDtoProps
): EnumReadingDtoProps => ({
  description: item?.description,
  id: item?.id,
})
